import React from 'react'
import messageUtil from 'utils/messageUtil'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import { SocialWebDomainsWidget } from 'schemas/SocialWebDomainsWidgetSchema'
import { InsightData } from 'schemas/action/InsightDataSchema'
import BarChart from '../../../visualization/Bar'
import { useDashboardWidgetData } from '../../../../hooks/useWidgetState'
import { useDashboardWidgetSetting } from '../../../../hooks/useDashboardState'
import {
  convertToBarData,
  getInsightDataNames,
  getThemeColorByCountType,
  getInsightDataByName
} from './utils'

interface DomainsProps {
  widgetId: number
  onClick: (insightData: InsightData) => void
}

const Domains = ({ widgetId, onClick }: DomainsProps): React.ReactElement => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebDomainsWidget>(widgetId)
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)

  const formatedData = convertToBarData(widgetData, widgetSetting)
  const xCategories = getInsightDataNames(widgetData, widgetSetting)
  const yAxisTitle = messageUtil.countType(widgetSetting.countType!)

  const handleClick = ({ category: insightDataName }: { category: string }) => {
    const insighData = getInsightDataByName(widgetData, widgetSetting, insightDataName)
    onClick(insighData!)
  }

  return (
    <BarChart
      data={formatedData}
      xAxisTitle=""
      yAxisTitle={yAxisTitle}
      xCategories={xCategories}
      showDataLabels
      colorSetting={getThemeColorByCountType(widgetSetting.countType!)}
      xAxisLabelStyle="large"
      yAxisAllowDecimals={false}
      onClick={handleClick}
    />
  )
}

export default React.memo(Domains)
